module.exports = __webpack_public_path__ + "img/108-35-plan.8bcaacaa.jpg";